import '../../pages/App.css';
import { HeaderMain } from '../../components/home/header/Header.js';
import { Services } from '../../components/home/services/Services.js';
import { Section } from '../../components/home/section/Section.js';
import { HeroSection } from '../../components/home/hero-section/HeroSection.js';
import { TechSection } from '../../components/home/tech-section/TechSection.js';
import { TestimonialSection } from '../../components/home/testimonial-section/TestimonialSection.js';
import { Contact } from '../../components/home/contact/Contact.js'
// import { NewsSection } from '../../components/home/news-section/NewsSection';

function Home() {
  return (
    <div className="App">
      <HeaderMain />
      <div id="hero"><HeroSection /></div>
      <div id="section"><Section /></div>
      <div id="services"><Services /></div>
      <div id="testimonials"><TestimonialSection /></div>
      {/* <div id="news"><NewsSection /></div> */}
      <div id="tech"><TechSection /></div>
      <div id="footer"><Contact/></div>
    </div>
  );
}

export default Home;
